module.exports = __webpack_public_path__ + "img/calendar-14.12a58d28.svg";